// State
import { state } from '../store/store.page-params';
import { CategoryType } from '../utils/utils.landing';

// Keeps props passed by outer page in state. Props are default to KBB
export const onReceivedParams = ({ entry, offerCode, lnxCode, utmSource = '', isAdmin = false, category = 'ico-component', dealerName = '' }: Params) => {
  state.category = category;
  state.entry = entry ?? '';
  state.isAdmin = isAdmin;
  state.lnxCode = lnxCode ?? 'KBBOWNSLP';
  state.offerCode = offerCode ?? 'B';
  state.utmSource = utmSource ?? '';
  state.dealerName = dealerName;
};

const onReceivedTrackingCategory = (category: CategoryType) => {
  if (Object.values(CategoryType).includes(category)) {
    state.category = `ico-${category}`;
  }
};

interface Params {
  entry: string;
  offerCode: string;
  lnxCode: string;
  utmSource?: string;
  isAdmin?: boolean;
  category?: string;
  dealerName?: string;
}

const actions = {
  onReceivedParams,
  onReceivedTrackingCategory,
};

export { actions };
export default actions;
